//trackingData.ts

export type TrackingRecord = {
  id: string
  modeOfPayment: string
  checkEFTNumber: string
  insuranceCarrier: string
  amount: string
  issueDate: string
  receivedOn: string
  postedDate: string
  numberOfClaims: string
  checkStatus: string
}

export const trackingData: TrackingRecord[] = [
  {
    id: '1',
    modeOfPayment: 'Wire',
    checkEFTNumber: 'BN123456789',
    insuranceCarrier: 'Blue Shield',
    amount: '100.00',
    issueDate: '2024-03-18',
    receivedOn: '2024-03-19',
    postedDate: '2024-03-20',
    numberOfClaims: '5',
    checkStatus: 'Cleared',
  },
  {
    id: '2',
    modeOfPayment: 'E-Payment',
    checkEFTNumber: 'BN987654321',
    insuranceCarrier: 'Aetna',
    amount: '250.50',
    issueDate: '2024-03-16',
    receivedOn: '2024-03-17',
    postedDate: '2024-03-18',
    numberOfClaims: '3',
    checkStatus: 'Deposited',
  },
  {
    id: '3',
    modeOfPayment: 'Direct',
    checkEFTNumber: 'BN456789123',
    insuranceCarrier: 'United Healthcare',
    amount: '175.75',
    issueDate: '2024-03-14',
    receivedOn: '2024-03-15',
    postedDate: '2024-03-16',
    numberOfClaims: '8',
    checkStatus: 'Processing',
  },
]
